export enum MFAProvider {
  TOTP = 'totp',
  NONE = 'none',
}
